import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import styled from 'styled-components';
import { translate } from "react-i18next";
import LayerList from './../map/popups/LayerList';

const Title = styled.h3`
    margin: 0;
`;

const TitleWrapper = styled.div`
    width: calc(100% - 10px);
    background: linear-gradient(0deg, #263650 0%, #082242 100%);
    color: #ffffff;
    padding: 5px;
    height: 25px;
`;

const MapContentWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export class MapModeContent extends React.Component {
    render() {
        const { t } = this.props;
        return (
            <MapContentWrapper>
                <TitleWrapper>
                    <Title>{t('Legend')}</Title>
                </TitleWrapper>
                <LayerList />
            </MapContentWrapper>
        );
    }
};

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(MapModeContent));


// WEBPACK FOOTER //
// ./src/containers/content/rightPanelContent/MapModeContent.jsx